import React from "react";
import styles from "./TestQueriesResultModal.module.css";

export type TestQueryResult = {
  field: string;
  query: string;
  answer: string;
  confidence: number;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  results: TestQueryResult[];
};

const TestQueriesResultModal: React.FC<Props> = ({
  isOpen,
  onClose,
  results,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.title}>Test Queries Result</div>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <ul className={styles.resultList}>
          {results.map((r, i) => (
            <li key={i} className={styles.resultItem}>
              <div>
                <strong>Field:</strong> {r.field}
              </div>
              <div>
                <strong>Question:</strong> {r.query}
              </div>
              <div>
                <strong>Answer:</strong> {r.answer}
              </div>
              <div>
                <strong>Confidence:</strong> {r.confidence}%
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TestQueriesResultModal;
